import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SafetyAnalyticsActions } from './safety-analytics.actions';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';
import { SafetyEventsQueryParams } from '@app/core/api/safety-analytics';
import {
  selectSafetySummary,
  selectSafetyTrend,
  selectSafetyLoading,
  selectSafetyError,
  selectSafetyEvents,
  selectSafetyEventsTotal
} from './safety-analytics.selectors';

/**
 * Facade service for safety analytics state management
 * Provides clean API for components to interact with safety analytics NgRx store
 */
@Injectable({
  providedIn: 'root'
})
export class SafetyAnalyticsFacade {
  private readonly store = inject(Store);

  // Observables
  readonly summary$ = this.store.select(selectSafetySummary);
  readonly trend$ = this.store.select(selectSafetyTrend);
  readonly events$ = this.store.select(selectSafetyEvents);
  readonly eventsTotal$ = this.store.select(selectSafetyEventsTotal);
  readonly loading$ = this.store.select(selectSafetyLoading);
  readonly error$ = this.store.select(selectSafetyError);

  // Actions
  loadSummary(params: AnalyticsQueryParams): void {
    this.store.dispatch(SafetyAnalyticsActions.loadSummary({ params }));
  }

  loadTrend(params: AnalyticsTrendQueryParams): void {
    this.store.dispatch(SafetyAnalyticsActions.loadTrend({ params }));
  }

  loadEvents(params: SafetyEventsQueryParams): void {
    this.store.dispatch(SafetyAnalyticsActions.loadEvents({ params }));
  }

  clearState(): void {
    this.store.dispatch(SafetyAnalyticsActions.clearSafetyAnalyticsState());
  }
}
